import { Location as ReactRouterLocation, Path } from 'react-router-dom';

function sortSearchParams(search: string): string {
  const searchParams = new URLSearchParams(search);
  const sortedParams = new URLSearchParams();

  // Sort the search parameters alphabetically
  Array.from(searchParams.keys()).sort().forEach((key) => {
    const paramValue = searchParams.get(key) as string;
    sortedParams.append(key, paramValue);
  });

  return (sortedParams.size > 0 ? '?' : '') + sortedParams.toString();
}

function toLocationKey(pathname: string, search: string): string {
  return toPathKey(pathname) + sortSearchParams(search);
}

export function toPathKey(pathname: string): string {
  const indexOfSearch = pathname.indexOf('?');
  if (indexOfSearch !== -1) {
    pathname = pathname.substring(0, indexOfSearch);
  }
  const indexOfFragment = pathname.indexOf('#');
  if (indexOfFragment !== -1) {
    pathname = pathname.substring(0, indexOfFragment);
  }
  if (pathname.endsWith('/')) {
    return pathname;
  };
  return pathname + '/';
}

export function pathToLocationKey(path: Path): string {
  return toLocationKey(path.pathname, path.search);
};

export function reactRouterLocationToLocationKey(location: ReactRouterLocation): string {
  return pathToLocationKey(location);
};

export function locationToLocationKey(location: Location): string {
  return toLocationKey(location.pathname, location.search);
};

export function urlToLocationKey(url: string): string {
  const parsedUrl = new URL(url);
  return toLocationKey(parsedUrl.pathname, parsedUrl.search);
};
